
import '../App.css';

function About({aboutRef}) {
  return (
    <div className="About" ref={aboutRef}>
      <h1>About</h1>
      <div className='About-Container'>
        <div className='About-Left'>
          <p>During my college days, I got introduced to coding in C++ and Java which intrigued me, and shortly after, through college placements, I was offered an internship opportunity as a Software Developer. During my time as an intern, I learned the basics of web development (HTML, CSS, PHP, JavaScript), I wanted to explore this domain and upskill myself, therefore I signed up for a 7-month long military style Coding Bootcamp at Masai School (Full Stack Web Development Programme).</p>
          <p>At Masai School, after completing my journey as a student (500+ hours of learning!) I was presented with an opportunity to become a teaching associate, and as I always wanted to contribute towards the education sector, I gladly accepted the opportunity.</p>
          <p>As a teaching associate at Masai School, I mentored and managed more than 100+ students, helping them with their daily coding-related doubts and concepts. After such a wonderful experience full of learning, I am now confident to take on the role of a Software Developer and begin the next phase of my life building real-world applications and customer facing products!</p>
          <button className='Resume-Btn' onClick={() => {
            window.open("https://drive.google.com/file/d/105BzvUNwSr6OZlbYOKSX0hRoopj5WD58/view?usp=sharing", '_blank')
          }}>Resume</button>
        </div>
        <div className='About-Right'>
          <img src="https://res.cloudinary.com/dmazpbyhl/image/upload/v1649441364/Untitled_design_1_i2ncap.png" alt="" srcset="" />
        </div>
      </div>
    </div>
  );
}

export default About;
